import { inject, Injectable, signal } from '@angular/core';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { RecruitmentService } from '../../../../../../core/services/recruitment.service';
import { resetOnLeavingRecruitment } from './recruitment-scope';

/**
 * Unread count behind the Inbox tab badge. Same scope as the other recruitment stores: provided on the `recruitment`
 * route and back to zero when a navigation leaves Recruitment.
 */
@Injectable()
export class RecruitmentInboxBadgeStore {
  private readonly recruitment = inject(RecruitmentService);
  private readonly countState = signal(0);
  /** Incremented on reset; a refresh that started in an earlier visit is ignored. */
  private visit = 0;

  readonly count = this.countState.asReadonly();

  constructor() {
    resetOnLeavingRecruitment(() => this.reset());
  }

  /** Re-reads the unread count; a failed request keeps the last known count so the badge never flickers away. */
  refresh(): Promise<void> {
    const visit = this.visit;
    return new Promise<void>((resolve) => {
      this.recruitment
        .inboxUnreadCount()
        .pipe(catchError(() => of({ count: this.countState() })))
        .subscribe({
          next: (result) => {
            if (visit === this.visit) this.countState.set(result.count ?? 0);
          },
          complete: () => resolve(),
        });
    });
  }

  reset(): void {
    this.visit++;
    this.countState.set(0);
  }
}
